module.exports = __webpack_public_path__ + "static/media/loewy_happy-hour.b98ba294.jpg";